class BundleBuilder extends HTMLElement {
  constructor() {
    super();
    this.mainElement = '[js-selected-products-wrapper]';
    this.productWrapperSelector = '[js-product-wrapper]';
    this.productTitleSelector = '[js-product-card-title]';
    this.cardMediaSelector = '[js-card-content-elm]';
    this.selectProductBtnSelector = '[js-select-product-btn]';
    this.quantityInputSelector = '[js-quantity-input]';
    this.incrementBtnSelector = '[js-quantity-increment]';
    this.decrementBtnSelector = '[js-quantity-decrement]';
    this.selectionBoxSelector = '[js-selection-box]';
    this.selectionBoxListSelector = '[js-selection-box-list]';
    this.bundleTypeSelector = '[js-bundle-type-selector]';

    this.removeProductSelector = '[js-bundle-product-cross-icon]';
    if(window.innerWidth >= 767) {
      this.collectionLinksSelector       = '[js-collection-links]';
    } else {
      this.collectionLinksSelector       = '[js-collection-links-mob]';
    }
    this.totalRegularPrice = '[js-bundle-regular-price]';
    this.totalComparePrice = '[js-bundle-compare-price]';
    this.remainingProductCount = '[js-selection-remaining-count]'
    this.remainingProductCountWrap = '[js-selection-remaining-count-wrap]'
    this.bundleDiscountAmountWrap = '[js-selection-discount-amount-wrap]'
    this.bundleDiscountAmount = '[js-selection-discount-amount]'
    

    this.selectionCountWrappers = this.querySelector('[js-selection-count-wrapper]');
    
    this.selectionCountMobWrappers = this.querySelector('[js-selection-count-wrapper-mob]');
    
    
    this.selectionCounts = this.querySelectorAll('[js-selection-count]');
    this.addToCartBtns = this.querySelectorAll('[js-bundle-addToCart-btn]');
    this.bundleCompletedMsgs = this.querySelectorAll('[js-bundle-completed-msg]');
    this.bundleProcessMsgs = this.querySelectorAll('[js-bundle-processing-msg]');
    this.selectionRemainingCounts = this.querySelectorAll('[js-remaining-count]');

    // bundle popup selectors
    this.bundlePopupWraper = this.querySelector('[js-hb-bundle-popup-wrap]')
    this.productPopupDetailBtn = '[hb-product-details-text]'
    this.popupCloseIcon = this.querySelectorAll('[js-hb-popup-cross-icon]');

    this.discountPercentageText = this.querySelectorAll('[js-selection-product-discount-percetage]')

    this.crossBtn = this.querySelectorAll('[js-bundle-products-list-cross-btn]')
    this.storeCurrency = this.querySelector('[data-store-currency]').dataset.storeCurrency

    this.totalBox = 3;
    this.products = [];
    this.discount = this.querySelector('[js-hb-bundle-product-price-1]').value;

    this.selectedBox4 = this.querySelector('.hb_feature-collection__bundle-option.active[data-value="4"]');
    this.selectedBox3 = this.querySelector('.hb_feature-collection__bundle-option.active[data-value="4"]');

    this.addEventListener('click', (event) => {
      this.querySelectorAll(this.selectProductBtnSelector).forEach(selectProductBtn => {
        if (selectProductBtn.contains(event.target)) {

          const parent = selectProductBtn.closest(this.productWrapperSelector);
          const quantityField = parent.querySelector(this.quantityInputSelector);

          quantityField.stepUp();

          parent.classList.add('selected');
          this.addProductToBox(parent);
          this.updateStatus();
        }

      })

      this.querySelectorAll(this.incrementBtnSelector).forEach(incrementBtn => {

        if (incrementBtn.contains(event.target)) {
          const parent = incrementBtn.closest(this.productWrapperSelector);
          const quantityField = parent.querySelector(this.quantityInputSelector);
          quantityField.stepUp();
          this.addProductToBox(parent);
          // this.selectedProductWrapperHandler();
        }
      })

      this.querySelectorAll(this.decrementBtnSelector).forEach(decrementBtn => {
        if (decrementBtn.contains(event.target)) {
          const parent = decrementBtn.closest(this.productWrapperSelector);
          const currentProductId = Number(parent.dataset.productId);
          const quantityField = parent.querySelector(this.quantityInputSelector);
          if (Number(quantityField.value) > 0) {
            quantityField.stepDown();
          }
          // this.selectedProductWrapperHandler();
          this.removeProductFromBox(currentProductId, parent);
        }
      })

      this.querySelectorAll(this.removeProductSelector).forEach(removeItem => {
        if (removeItem.contains(event.target)) {
          // pass id, parent
          const selectedProductLine = removeItem.closest(`${this.selectionBoxSelector}[data-product-id]`)
          const pId = Number(selectedProductLine.dataset.productId)
          const parent_ = this.querySelector(`${this.productWrapperSelector}[data-product-id="${pId}"]`)
          const quantityField = parent_.querySelector(this.quantityInputSelector);
          if (Number(quantityField.value) > 0) {
            quantityField.stepDown();
          }
          this.removeProductFromBox(pId, parent_)
          // if (this.totalBox > 4) {
          //   this.totalBox -= 1
          // }
        }
      })
      
      // collections 
      this.querySelectorAll(this.collectionLinksSelector).forEach((cLink) => {
        if(cLink.contains(event.target)) {
          this.querySelectorAll(this.collectionLinksSelector).forEach((cLink) => { cLink.classList.remove('selected')})
          const collectionLink = cLink.dataset.collectionLink
          
          cLink.classList.add('selected')
          
          this.fetchCollection(collectionLink)
      
        }
      })

      // bundle selected products cross btn
      this.crossBtn.forEach(crossBtn =>{
        if(crossBtn.contains(event.target)) {
          this.querySelector('[js-selected-products-wrapper]')?.classList.remove('drawer-open')
        }
      })
      
      if(this.selectionCountMobWrappers.contains(event.target)) {
        if(window.innerWidth < 768) {
          const openDrawerClass= 'drawer-open'
          
          const drawerWrapper = this.selectionCountWrappers.closest('[js-selected-products-wrapper]')
     
          if(!drawerWrapper.classList.contains(openDrawerClass)) {
            drawerWrapper?.classList.add(openDrawerClass)
          } else {
            drawerWrapper?.classList.remove(openDrawerClass)
          }
        }  
      }
  

      this.popupCloseIcon.forEach(crossBtn =>{
        if(crossBtn.contains(event.target)) {
          this.bundlePopupWraper?.classList.remove('active')
        }
      })
    })

    this.addToCartBtns.forEach(addToCartBtn => {
      addToCartBtn.addEventListener('click', (e) => {

        this.addToCartBtns.forEach(addToCartBtn => {
          addToCartBtn.classList.add('loading');
          addToCartBtn.querySelector('.loading__spinner')?.classList.remove('hidden');
       })

        const productsId = [];
        const products = [];


        this.products.forEach(item => {
            
            productsId.push(item.id)
            products.push({
              id: item.id,
              quantity: 1,
              properties:{
                _bundle_discount: this.discount,
                _bundle_product: true,
                _bundle_id: new Date().getTime(),
                _parent_container_id : this.dataset.productContainerId
              }
            })

            
        })
        this.addToCart(products);
        this.addToCartBtns.forEach(addToCartBtn => {
          addToCartBtn.classList.add('loading');
        })  
      })
    })

    this.createBox(this.totalBox);

  }
  
  addProductToBox(parent) {
    const imageUrl = parent.dataset.productImageUrl;
    const productId = Number(parent.dataset.productId);
    const title = parent.dataset.productTitle;
    const price = Number(parent.dataset.productPrice);
    
    this.products.push({
      id: productId,
      imageUrl,
      title,
      price,
      quantity: 1,
    })

    if (this.products.length > 3 && this.totalBox < 4){
      this.totalBox += 1
    }

    if (this.products.length >= 3) {
      // show atc btn
      this.addToCartBtns.forEach(addToCartBtn => {
        addToCartBtn.classList.remove('hidden');
      })
      // hide add to bundle 
      this.selectionCountWrappers.classList.add('hidden');
      
    }

    this.updateDiscount();
    if (this.products.length) {
      this.fillProductInSelectionBox(this.products);
    }
    this.priceHandler();

  }

  createBox(number) {
    this.querySelector(this.selectionBoxListSelector).innerHTML = '';
    let productbox = '';
    for (let i = 0; i < number; i++) {
      productbox += `<div class="hb_feature-collection__item" data-index="${i}" js-selection-box>
                        <div class="hb_feature-collection__header">
                            <h4 class="hb_feature-collection__label">Select a Box</h4>
                            <div class="hb_feature-collection__icon-plus">
                              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <g clip-path="url(#clip0_10003_6768)">
                              <path d="M6.79084 12.6432C6.9223 13.1143 6.76205 13.5461 6.79851 14.071C6.82922 14.5211 6.87912 14.6775 6.8628 15.1361C6.85705 15.3012 6.76781 15.5756 6.79275 15.7906C6.9127 16.0842 8.28586 16.0055 8.58429 15.9249C8.63994 15.9096 8.72918 15.6879 8.72726 15.5977C8.70807 14.1075 8.69656 14.8876 8.6409 13.3705C8.59388 12.077 8.42883 10.8238 8.46722 9.53221C8.36838 8.27804 8.33288 8.52657 8.4058 7.30887C8.45666 6.53065 8.55166 5.84455 8.46818 5.10376C8.37606 4.42246 8.46818 3.81697 8.48449 3.20092C8.48641 2.80461 8.55262 2.45916 8.56414 2.08205C8.58716 1.72317 8.55358 1.33166 8.52959 1.03707C8.44994 0.710812 8.44899 -0.0779613 7.77056 0.00936031C7.1526 0.00936031 7.17179 -0.0290228 6.86568 0.0496626C6.80555 0.189121 6.7742 0.349371 6.77164 0.530411C6.70063 1.50918 6.76685 2.51098 6.68432 3.57035C6.56629 5.07593 6.78892 6.67843 6.6325 8.06118C6.52791 8.98717 6.57877 8.81349 6.57877 9.39979C6.59316 9.67423 6.62291 9.9669 6.59124 10.3075L6.79084 12.6432Z" fill="#0C0C0C"/>
                              <path d="M3.19105 7.51715C2.74197 7.66108 2.32072 7.51714 1.81598 7.57088C1.38417 7.62078 1.23543 7.67452 0.79211 7.67931C0.63282 7.68123 0.364138 7.60639 0.157829 7.64093C-0.119489 7.77527 0.0340432 9.14267 0.127122 9.4363C0.144395 9.49196 0.35934 9.56872 0.444742 9.56392C1.85532 9.4766 1.11549 9.49771 2.55294 9.38736C3.78024 9.29812 4.97107 9.10908 6.20701 9.12636C7.40456 9.00833 7.16658 8.97762 8.33343 9.03232C9.07998 9.07166 9.73921 9.1561 10.4503 9.05823C11.1028 8.95267 11.6872 9.0304 12.2802 9.02848C12.6611 9.01888 12.996 9.07262 13.3607 9.0707C13.708 9.07934 14.0842 9.0304 14.3663 8.99393C14.6772 8.89894 15.4372 8.85864 15.3153 8.18501C15.2808 7.568 15.3192 7.58528 15.227 7.28397C15.0914 7.23087 14.9376 7.2072 14.7655 7.21296C13.8337 7.18993 12.8847 7.2926 11.8743 7.23791C10.4387 7.16114 8.91398 7.40583 7.58688 7.26861C6.69735 7.17745 6.86528 7.22543 6.30296 7.23407C6.04004 7.25326 5.75888 7.28685 5.43167 7.2619L3.19009 7.51523L3.19105 7.51715Z" fill="#0C0C0C"/>
                              </g>
                              <defs>
                              <clipPath id="clip0_10003_6768">
                              <rect width="15.3283" height="16" fill="white"/>
                              </clipPath>
                              </defs>
                              </svg>
                            </div>
                        </div>
                    </div>
                    `
    }
    this.querySelector(this.selectionBoxListSelector).insertAdjacentHTML('beforeend', productbox);
  }

  fillProductInSelectionBox(products) {

    this.createBox(this.totalBox);
    products.forEach((item, index) => {

      const originalPrice = item.price;
      const discountedPrice = (100 - this.discount) / 100 * item.price;

      this.querySelector(`${this.selectionBoxSelector}[data-index="${index}"]`).innerHTML = '';
      this.querySelector(`${this.selectionBoxSelector}[data-index="${index}"]`).classList.add('filled');
      this.querySelector(`${this.selectionBoxSelector}[data-index="${index}"]`).setAttribute('data-product-id', item.id);
      this.querySelector(`${this.selectionBoxSelector}[data-index="${index}"]`).setAttribute('data-product-price', 6767);
      this.querySelector(`${this.selectionBoxSelector}[data-index="${index}"]`).insertAdjacentHTML('beforeend', `
        <div class="hb_feature-collection__item selected" js-selection-box>
            <div class="hb_feature-collection__header">
                <h4 class="hb_feature-collection__label">Select a Box</h4>
            </div>
            <div class="hb_feature-collection__inner">
                <div class="hb_feature-collection__product--img">
                    <img src="${item.imageUrl}" alt="${item.title}">
                </div>
                <div class="hb_feature-collection__col">
                    <h4 class="hb_feature-collection__product--title">${item.title}</h4>
                    <div class="hb_price-wrapper">
                        <span class="hb_feature-collection__product--price" js-discounded-price>${this.storeCurrency}${discountedPrice.toFixed(2)}</span>
                        <span class="hb_feature-collection__Product--compare-price">${this.storeCurrency}${originalPrice.toFixed(2)}</span>
                    </div>
                </div>
            </div>
            <div class="hb_feature-collection__icon" js-bundle-product-cross-icon >
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7.22656 7.22656L16.7725 16.7725" stroke="black" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M7.22656 16.7725L16.7725 7.22652" stroke="black" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </div>
        </div>
        `
      )
    })
    this.updateStatus();
  }

  updateStatus() {
    let activeBundleTypeSelector = this.querySelector(`${this.bundleTypeSelector}.active`)
    let activeBundleTypeSelectorValue = parseInt(activeBundleTypeSelector.dataset.value)

    if(this.products.length >= 3) {
      this.selectedProductWrapperHandler()
    }

    if(this.products.length == 4) {
        this.querySelectorAll(this.selectProductBtnSelector).forEach(item => {
        item.classList.add('disabled')
      })
      
      this.querySelectorAll(this.incrementBtnSelector).forEach(item => {
        item.classList.add('disabled')
      })
    }
    else {
      this.querySelectorAll(this.selectProductBtnSelector).forEach(item => {
        item.classList.remove('disabled')
      })
      this.querySelectorAll(this.incrementBtnSelector).forEach(item => {
        item.classList.remove('disabled')
      })
    }

    this.querySelectorAll('[js-modal-open-icon]').forEach(item => {
      item.classList.remove('disabled')
    })


    this.selectionCountWrappers.classList.remove('hidden');
    
    this.selectionCountMobWrappers.classList.remove('hidden');

    if(this.products.length >= 1){
      this.selectionCountWrappers.classList.add('active');
    }
    else {
      this.selectionCountWrappers.classList.remove('active');
    }

    this.addToCartBtns.forEach(addToCartBtn => {
      addToCartBtn.classList.add('hidden');
    })

    this.bundleCompletedMsgs.forEach(bundleCompletedMsg => {
      bundleCompletedMsg.classList.add('hidden');
    })
    this.bundleProcessMsgs.forEach(bundleProcessMsg => {
      bundleProcessMsg.classList.remove('hidden');
    })
    this.selectionCounts.forEach((selectionCount) => {
      selectionCount.innerHTML = `${this.products.length}/${this.totalBox}`;
    })

    this.selectionRemainingCounts.forEach((selectionRemainingCount) => {
      selectionRemainingCount.innerHTML = this.totalBox - this.products.length;
    })

    this.querySelectorAll(this.productTitleSelector).forEach(item => {
      item.classList.remove('disabled')
    })
    this.querySelectorAll(this.cardMediaSelector).forEach(item => {
      item.classList.remove('disabled')
    })


    if (this.products.length === 0) {
      this.bundleProcessMsgs.forEach(bundleProcessMsg => {
        bundleProcessMsg.classList.add('hidden');
      })
    }

    
    this.querySelectorAll(this.remainingProductCountWrap).forEach(remainingCountWrap=>{
        if (this.products.length >= 3) {
          remainingCountWrap.classList.add('hidden')
        }
        else {
          remainingCountWrap.classList.remove('hidden')
        }
    })
    this.querySelectorAll(this.bundleDiscountAmountWrap).forEach(bundleDiscoutWrap=>{
      if (this.products.length >= 3) {
        
        bundleDiscoutWrap.classList.remove('hidden')
      }
      else {
        bundleDiscoutWrap.classList.add('hidden')
      }
  })


    activeBundleTypeSelector = this.querySelector(`${this.bundleTypeSelector}.active`)
    activeBundleTypeSelectorValue = parseInt(activeBundleTypeSelector.dataset.value)
    if (this.products.length > 2 || this.products.length == activeBundleTypeSelectorValue) {
      this.addToCartBtns.forEach(addToCartBtn => {
        addToCartBtn.classList.remove('hidden');
      })
      this.selectionCountWrappers.classList.add('hidden');
      this.selectionCountMobWrappers.classList.add('hidden');
    }

  }

  removeProductFromBox(id, parent) {
    const otherProducts = this.products.filter(product => product.id !== id);
    const currentProducts = this.products.filter(product => product.id == id);
    if (this.totalBox == 4) {
        this.totalBox -= 1
      }
    currentProducts.splice(0, 1)
    if (currentProducts.length === 0) {
      parent.classList.remove('selected');
    }
    this.products = [...currentProducts, ...otherProducts];

    this.updateDiscount();
    this.fillProductInSelectionBox(this.products);
    this.priceHandler();
  }

  selectedProductWrapperHandler() {
    const addedAnyProduct = this.querySelectorAll(`${this.selectionBoxSelector}.filled`).length
    if(window.innerWidth < 767) {
      if(addedAnyProduct) {
        this.querySelector('[js-selected-products-wrapper]')?.classList.add('drawer-open')
      } else {
        this.querySelector('[js-selected-products-wrapper]')?.classList.remove('drawer-open')
      }   
    }
  }

  priceHandler() {

    let totalBundlePrice = 0;
    let totalDiscountedPrice = 0;

    this.products.forEach(item => {
      totalBundlePrice += item.price
    })

    totalDiscountedPrice = ((100 - this.discount) * totalBundlePrice) / 100;

    const bundlePriceWrappers = this.querySelectorAll('[js-bunlde-price-wrapper]')

    bundlePriceWrappers.forEach(priceTagWrapper => {
      priceTagWrapper.querySelector(this.totalRegularPrice).innerText = this.storeCurrency + totalDiscountedPrice.toFixed(2);
      priceTagWrapper.querySelector(this.totalComparePrice).innerText = this.storeCurrency + totalBundlePrice.toFixed(2);
    })

    this.addToCartBtns.forEach(atcBtn => {
      atcBtn.querySelector(this.totalRegularPrice).innerText = this.storeCurrency + totalDiscountedPrice.toFixed(2)
      atcBtn.querySelector(this.totalComparePrice).innerText = this.storeCurrency + totalBundlePrice.toFixed(2)

      console.log('totalbundle price ', totalBundlePrice)
      
    })

    this.querySelectorAll(this.remainingProductCount).forEach(remainingCount=>{
      if(this.products.length < 3) {
        const remainCountNumber = 3;
        if(this.products.length == 2) {
          this.querySelectorAll(this.remainingProductCountWrap).forEach(countWrap=>{
            countWrap.innerHTML = `
            select <span js-selection-remaining-count>${remainCountNumber - this.products.length}</span> more product and <span class="hb_feature-collection--discount"js-selection-product-discount-percetage>save 5%</span>
            `
          })
        } else if(this.products.length == 1) {
          this.querySelectorAll(this.remainingProductCountWrap).forEach(countWrap=>{
            countWrap.innerHTML = `
            select <span js-selection-remaining-count>${remainCountNumber - this.products.length}</span> more products and <span class="hb_feature-collection--discount"js-selection-product-discount-percetage>save 5%</span>
      `
          })
        }
        else {
          this.querySelectorAll(this.remainingProductCountWrap).forEach(countWrap=>{
            countWrap.innerHTML = `
            select <span js-selection-remaining-count>${remainCountNumber - this.products.length}</span> products and <span class="hb_feature-collection--discount"js-selection-product-discount-percetage>save 5%</span>
      `
          })
        }
        remainingCount.innerHTML = `${remainCountNumber - this.products.length}`
      }
    })

    this.querySelectorAll(this.bundleDiscountAmount).forEach(bundleDiscountTag=>{  
      const discountAmount = totalBundlePrice - totalDiscountedPrice
      bundleDiscountTag.innerHTML =  this.storeCurrency + discountAmount.toFixed(2)
    })
       
  }
  // Add to cart
  async addToCart(products) {
    const requestBody = {
      items: products
    }

    const cartDrawer = document.querySelector('cart-drawer');
    requestBody.sections = cartDrawer.getSectionsToRender().map((section) => section.id);

    try {
      const resp = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        body: JSON.stringify(requestBody),
        headers: {
          "Content-Type": "application/json",
        },
      });
      const data = await resp.json();

      this.addToCartBtns.forEach(addToCartBtn => {
        addToCartBtn.classList.remove('loading');
      })

      cartDrawer.renderContents(data);
      if (cartDrawer && cartDrawer.classList.contains('is-empty')) cartDrawer.classList.remove('is-empty');

      this.resetBundleSelectBox()
      
    } catch(err){
      console.error({ err })
    }
    
  }

  fetchCollection(url) {
    const url_ = location.origin + url + '?view=bundle&default=true'
    fetch(url_)
    .then((response) => response.text())
    .then((text_) => {
      try {
        const html_ = new DOMParser().parseFromString(text_, 'text/html')
        const productGrid = html_.querySelector('.hb_feature-collection__product-grid')
        document.querySelector('.hb_feature-collection__product-grid').replaceWith(productGrid)
        this.updateStatus()

        this.querySelectorAll('.bundle-grid [js-product-wrapper]').forEach((gridItem) => {
          this.products.forEach(selectedProduct => {
            const gridItemId =Number(gridItem.dataset.productId)
            const selectedProductId= Number(selectedProduct.id)
            const gridItemCTABtn =gridItem.querySelector('[js-select-product-btn]')
            const gridItemQuantity = gridItem.querySelector(this.quantityInputSelector)

            const allSameItems = this.products.filter(prods => prods.id == gridItemId)              

            if(gridItemId === selectedProductId) {
              gridItemQuantity.value = Number(allSameItems.length)

              if(!gridItem.classList.contains('selected')) {
                gridItem.classList.add('selected')
              }
              if(!gridItemCTABtn.classList.contains('disabled')) {
                gridItemCTABtn.classList.add('disabled')
              }
            }
          })
        })
        
      }catch(err) {

      }
    }).then(() => {
    })
  }
  
  resetBundleSelectBox() {
    const bundleSelector = this.querySelectorAll(this.bundleTypeSelector)
    this.createBox(parseInt(bundleSelector[0].dataset.value))
    this.totalBox = parseInt(bundleSelector[0].dataset.value);
    this.products = []
    this.updateDiscount()
    this.priceHandler();
    this.updateStatus();
    this.querySelector(`.selected${this.collectionLinksSelector}`).click();
  }

  updateDiscount() {
    this.discount = this.querySelector('[js-hb-bundle-product-price-1]').value;
    if(this.products.length > 3) {
      this.discount = this.querySelector('[js-hb-bundle-product-price-2]').value;
    }
    this.updateStep();
  }

  updateStep() {
    this.querySelectorAll(`${this.bundleTypeSelector}`).forEach(bundleType => {
      bundleType.classList.remove('active');        
    })

    if(this.products.length > 3) {
      this.querySelectorAll(`${this.bundleTypeSelector}[data-value="4"]`).forEach(bundleType => {
        bundleType.classList.add('active');        
      })
    } else {
      this.querySelectorAll(`${this.bundleTypeSelector}[data-value="3"]`).forEach(bundleType => {
        bundleType.classList.add('active');        
      })
    }
  }

}

customElements.define('bundle-builder', BundleBuilder)
